"use client";

import { c as _c } from "react/compiler-runtime";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import clsx from "clsx";
import * as React from "react";
const ScrollArea: React.ForwardRefExoticComponent<React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> & React.RefAttributes<React.ElementRef<typeof ScrollAreaPrimitive.Root>>> = React.forwardRef((t0, ref) => {
  const $ = _c(15);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = clsx("relative overflow-hidden", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== ref) {
    t2 = <ScrollAreaPrimitive.Viewport className="h-full w-full rounded-[inherit]" ref={ref}>{children}</ScrollAreaPrimitive.Viewport>;
    $[6] = children;
    $[7] = ref;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ScrollBar />;
    t4 = <ScrollAreaPrimitive.Corner />;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props || $[12] !== t1 || $[13] !== t2) {
    t5 = <ScrollAreaPrimitive.Root className={t1} {...props}>{t2}{t3}{t4}</ScrollAreaPrimitive.Root>;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
});
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
const ScrollBar: React.ForwardRefExoticComponent<React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar> & React.RefAttributes<React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>>> = React.forwardRef((t0, ref) => {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  const t2 = orientation === "vertical" && "h-full w-2xs border-l border-l-transparent border-none p-[1px]";
  const t3 = orientation === "horizontal" && "h-2xs flex-col border-t border-t-transparent border-none p-[1px]";
  let t4;
  if ($[4] !== className || $[5] !== t2 || $[6] !== t3) {
    t4 = clsx("flex touch-none select-none transition-colors bg-neutral-12", t2, t3, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScrollAreaPrimitive.ScrollAreaThumb className="relative flex-1 rounded-full bg-neutral-100" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== orientation || $[10] !== props || $[11] !== ref || $[12] !== t4) {
    t6 = <ScrollAreaPrimitive.ScrollAreaScrollbar ref={ref} orientation={orientation} className={t4} {...props}>{t5}</ScrollAreaPrimitive.ScrollAreaScrollbar>;
    $[9] = orientation;
    $[10] = props;
    $[11] = ref;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
});
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
export { ScrollArea, ScrollBar };